import {Base, PostBase, PostObjectResponse} from "./metadata";

export class ExternalProfile extends Base {
  eID!: string | undefined
  titles: Array<string> = []
  firstName: string = ""
  lastName: string = ""
  institution: string = ""
  country: string = ""
  vendorID: string = ""
  isOld: boolean = false

  get abstractID(): string | undefined {
    return this.eID
  }

  toPost(changes: ExternalProfile): ExternalProfilePost {
    return new ExternalProfilePost(this, changes);
  }

  static override parseFromPostResponse(post: ExternalParticipantPostResponse): ExternalParticipantPostResponse {
    post.updatedData = Object.assign(new ExternalProfile(), post.updatedData);
    return post
  }
}

export interface ExternalProfileEndpointResponse {
  externalProfiles: Array<ExternalProfile>
}

export const TEST_EXTERNAL_PROFILE = {
  eID: "ID of the external profile",
  titles: ["Dr.", "Mrs."],
  firstName: "Firstname",
  lastName: "Lastname",
  institution: "Institution name",
  country: "Country name",
  vendorID: "VendorID",
} as ExternalProfile;

export class ExternalProfilePost extends PostBase {
  eID: typeof ExternalProfile.prototype.eID
  title: typeof ExternalProfile.prototype.titles
  firstName: typeof ExternalProfile.prototype.firstName
  lastName: typeof ExternalProfile.prototype.lastName
  institution: typeof ExternalProfile.prototype.institution
  country: typeof ExternalProfile.prototype.country
  vendorID: typeof ExternalProfile.prototype.vendorID

  constructor(source: ExternalProfile, newValue: ExternalProfile) {
    super(source, newValue);

    this.eID = newValue.eID
    this.title = newValue.titles
    this.firstName = newValue.firstName
    this.lastName = newValue.lastName
    this.institution = newValue.institution
    this.country = newValue.country
    this.vendorID = newValue.vendorID
  }

  override getSourceWrapper(): { (post: ExternalParticipantPostResponse): ExternalParticipantPostResponse } {
    return ExternalProfile.parseFromPostResponse;
  }
}

export type ExternalParticipantPostResponse = PostObjectResponse<ExternalProfile>

export enum AddExternalProfileActions{
  INTERNAL_ERROR = -1,
  ERROR = 0,
  ADD = 1,
  UPDATE = 2
}

export interface AddExternalProfileResponse {
  actionPerformed: AddExternalProfileActions,
  addedPerson: ExternalProfile
}
